import { render, staticRenderFns } from "./TreatmentSessionSelectCompetencyTests.vue?vue&type=template&id=3ce7e36a"
import script from "./TreatmentSessionSelectCompetencyTests.vue?vue&type=script&lang=js"
export * from "./TreatmentSessionSelectCompetencyTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports